/**
 * Past sheets and the 2026 Typst archive (Phase 8, Lane S): what the lists of past sheets,
 * the week views and "Use as a start" say about a 2025 sheet's Typst version.
 *
 * The archive (`archive/2026` of the course repository, indexed by server/archive) holds a
 * Typst port of every 2025 sheet: the same includes in the same order, plus what the 2025
 * ingest never kept — the second exercise of a file with two, the sheets' section headings —
 * and one sheet 2025 has no corpus entry for, the end-term preparation.
 */

/** A past sheet's Typst version in the 2026 archive, as a list of past sheets shows it. */
export interface ArchiveSheetSummary {
  /** the sheet file, relative to `archive/2026` (`tutorial-sheets/B/tutorialB.typ`) */
  path: string;
  title: string | null;
  /** the exercises a copy takes: every include that is not commented out, and the sheet's own */
  exercises: number;
  /** the section headings it prints between them */
  headings: number;
  /** of `exercises`, those no 2025 corpus exercise is (Studio never had them) */
  extra: number;
}

/** Id prefix of a past sheet that only the archive has (no 2025 corpus sheet): `a26/<path>`. */
export const ARCHIVE_SHEET_PREFIX = 'a26/';

/** Whether a past-sheet id names an archive-only sheet rather than a corpus sheet. */
export const isArchiveSheetId = (id: string): boolean => id.startsWith(ARCHIVE_SHEET_PREFIX) && !id.includes('#');

/**
 * Which past sheet a sheet of one week should start from when several years have one:
 * for a course (2026 Typst) sheet the newest with a Typst version, else the newest.
 * `list` is newest first.
 */
export function preferredPastSheet<T extends { typst?: ArchiveSheetSummary | null }>(list: readonly T[], course: boolean): T | null {
  if (!list.length) return null;
  if (course) {
    const typst = list.find((s) => s.typst);
    if (typst) return typst;
  }
  return list[0] ?? null;
}
